import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseURLInterceptor } from './api/interceptors/base-url.interceptor';
import { AuthInterceptor } from './api/interceptors/auth.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from './material/material.module';
import { AppStores } from './api/services/stores';

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular 21 bootstraps zoneless by default; components here mutate plain fields in subscribe callbacks.
    provideZoneChangeDetection(),
    AppStores,
    provideRouter(routes),
    importProvidersFrom(
      AppStores,
      NgxMaskDirective,
      NgxMaskPipe,
      MaterialModule,
      BrowserModule,
    ),
    provideAnimations(),
    provideNgxMask(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseURLInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ]
};
